import { reactive } from "vue";

export type DialogVariant = "primary" | "success" | "danger" | "warning" | "secondary";
type DialogMode = "alert" | "confirm";

type DialogOptions = {
  title?: string;
  variant?: DialogVariant;
  confirmText?: string;
  cancelText?: string;
};

type DialogState = {
  open: boolean;
  mode: DialogMode;
  title: string;
  message: string;
  variant: DialogVariant;
  confirmText: string;
  cancelText: string;
};

export const dialogState = reactive<DialogState>({
  open: false,
  mode: "alert",
  title: "",
  message: "",
  variant: "primary",
  confirmText: "Aceptar",
  cancelText: "Cancelar",
});

let dialogResolver: ((value: boolean) => void) | null = null;

function openDialog(mode: DialogMode, message: string, options: DialogOptions = {}) {
  dialogState.open = true;
  dialogState.mode = mode;
  dialogState.title = options.title || (mode === "confirm" ? "Confirmar" : "Mensaje");
  dialogState.message = message;
  dialogState.variant = options.variant || (mode === "confirm" ? "warning" : "primary");
  dialogState.confirmText = options.confirmText || (mode === "confirm" ? "Confirmar" : "Aceptar");
  dialogState.cancelText = options.cancelText || "Cancelar";
}

export function closeDialog(result = false) {
  dialogState.open = false;
  const resolver = dialogResolver;
  dialogResolver = null;
  resolver?.(result);
}

export function showAlert(message: string, options: DialogOptions = {}): Promise<void> {
  openDialog("alert", message, options);
  return new Promise((resolve) => {
    dialogResolver = () => resolve();
  });
}

export function showConfirm(message: string, options: DialogOptions = {}): Promise<boolean> {
  openDialog("confirm", message, options);
  return new Promise((resolve) => {
    dialogResolver = resolve;
  });
}
